import {
  SetServiceDependencies,
  UserOnboardingInputType
} from '../../infra/startup/types';
import { INavigationService } from '../navigationService';
import { InternalService } from '../../core/services';

export default abstract class BaseUserOnboardingService extends InternalService {
  private _userOnboardingInputData: UserOnboardingInputType;
  private _navigationService: INavigationService;

  constructor(props: UserOnboardingInputType) {
    super();
    this._userOnboardingInputData = props;
  }

  setDependencies({ services }: SetServiceDependencies): void {
    this._navigationService = services.navigationService;
    this._markAsReady();
  }

  getOnboardingPath(): string | undefined {
    return (
      this._userOnboardingInputData.path ||
      this._userOnboardingInputData.userOnboardingPath
    );
  }

  isUserOnboardingPath(path?: string): boolean {
    const pathToCheck = path || this._navigationService.location.pathname;

    return (
      pathToCheck === this._userOnboardingInputData.path ||
      pathToCheck === this._userOnboardingInputData.userOnboardingPath
    );
  }
}
